// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Cannot find module 'redux-saga' or its corresponding type declarations.ts(2307)
import { SagaMiddleware, Task } from 'redux-saga';
import { Saga } from '../../types';

export class SagaRegistry<C> {
  sagaMiddleware: SagaMiddleware<C>;

  sagas: Map<string, Task> = new Map();

  constructor(sagaMiddleware: SagaMiddleware<C>, initialRootSaga: Saga) {
    this.sagaMiddleware = sagaMiddleware;
    this.register('root', initialRootSaga);
  }

  async register(name: string, saga: Saga) {
    if (this.sagas.has(name)) return true;

    console.log('Registering async saga:', name);

    const task = this.sagaMiddleware.run(saga);
    this.sagas.set(name, task);

    return true;
  }
}
